import { render } from "./ChatAssistant.vue?vue&type=template&id=24ea0b04&scoped=true"
import script from "./ChatAssistant.vue?vue&type=script&lang=js"
export * from "./ChatAssistant.vue?vue&type=script&lang=js"

import "./ChatAssistant.vue?vue&type=style&index=0&id=24ea0b04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24ea0b04"]])

export default __exports__